// Completeness check for Company ID staff. Once someone is marked
// does_have_id_from_company their ID processing is DONE, so their record
// should be complete — EVERY field and document below (2026-07-26; this is
// deliberately wider than the blue "required for company ID processing"
// legend, which covers only what's needed BEFORE processing starts).
// Must stay in sync with the server-side copy in routes/team.js (GET /).
export const COMPANY_ID_FIELDS = [
    { key: 'date_of_birth', label: 'Date of Birth' },
    { key: 'place_of_birth', label: 'Place of Birth' },
    { key: 'passport_number', label: 'Passport Number' },
    { key: 'passport_issue_date', label: 'Passport Issue Date' },
    { key: 'passport_expiry_date', label: 'Passport Expiry Date' },
    { key: 'passport_issue_country', label: 'Nationality' },
    { key: 'passport_issue_place', label: 'Passport Issue Place' },
    { key: 'unified_number', label: 'Unified Number' },
    { key: 'eid', label: 'Emirates ID' },
    { key: 'eid_expiry_date', label: 'EID Expiry Date' },
    { key: 'mohre_person_code', label: 'MOHRE Person Code' },
    { key: 'work_permit_number', label: 'Work Permit Number' },
    { key: 'work_permit_expiry_date', label: 'Work Permit Expiry Date' },
    { key: 'service_start_date', label: 'First Labour Card Date' },
    { key: 'health_insurance_expiry', label: 'Health Insurance Expiry' },
    { key: 'phone_number', label: 'WhatsApp Number' },
];

export const COMPANY_ID_DOCS = [
    { type: 'personal_photo', label: 'Personal photo' },
    { type: 'passport', label: 'Passport photo' },
    { type: 'last_visa', label: 'Residency Visa / Entry Permit / Cancellation' },
    { type: 'labour_card', label: 'Labour card' },
    { type: 'eid_front', label: 'Emirates ID front' },
    { type: 'eid_back', label: 'Emirates ID back' },
    { type: 'health_insurance_card', label: 'Health insurance card' },
    { type: 'driving_license_front', label: 'Driving license front', driverOnly: true },
    { type: 'driving_license_back', label: 'Driving license back', driverOnly: true },
];

// hasDoc(type) lets Edit (uploaded documents map) and Add (locally staged
// files) plug in their own presence check. Fields the calling form doesn't
// manage (e.g. First Labour Card Date on the Add form) are skipped — a form
// must never nag about something it can't fill.
export const companyIdMissingList = (formData, hasDoc, isDriver) => {
    if (!formData.does_have_id_from_company) return [];
    return [
        ...COMPANY_ID_FIELDS
            .filter((f) => f.key in formData && !String(formData[f.key] || '').trim())
            .map((f) => f.label),
        ...COMPANY_ID_DOCS
            .filter((d) => (!d.driverOnly || isDriver) && !hasDoc(d.type))
            .map((d) => d.label),
    ];
};
